import { createContext, useContext, useState, useEffect } from "react";
import { host } from "./globalVariables";
import { getCleanUsers, getOOUserData } from "./networkFunctions";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
   const [user, setUser] = useState(null);
   const [loading, setLoading] = useState(true);
   const [authError, setAuthError] = useState();

   const buildFullUser = async (baseUser, usernameForLookup) => {
      let myFullUser = {};
      try {
         myFullUser = (await getOOUserData(usernameForLookup)) || {};
        
      } catch (err) {
         console.error("getOOUserData failed:", err);
      }
      return { ...baseUser, ...myFullUser };
   };

   useEffect(() => {
      const checkAuth = async () => {
         try {
            const res = await fetch(host + "/api/me", { credentials: "include" });
            if (res.ok) {
               const userData = await res.json();
               const fullUser = await buildFullUser(userData, userData.username);
               localStorage.setItem("user", JSON.stringify(fullUser));
               setUser(fullUser);
            } else {
               const errorMessage = await res.json();
               setAuthError(errorMessage.message);
            }
         } catch (err) {
            console.error(err);
            setUser(null);
         } finally {
            setLoading(false);
         }
      };
      checkAuth();
   }, []);

   // NEW: centralized login
   const login = async (username, password) => {
      const response = await fetch(host + "/api/login", {
         method: "POST",
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({ username, password }),
         credentials: "include",
      });

      const data = await response.json();

      if (!response.ok) {
         return { ok: false, message: data.message || "Login fehlgeschlagen. Bitte Daten prüfen." };
      }
console.log(data);

      const fullUser = await buildFullUser(data.user, data.user.username); // match /api/me's field name
      fullUser.username=fullUser.username??fullUser.name
      fullUser.Name=fullUser.username??fullUser.name
      localStorage.setItem("user", JSON.stringify(fullUser));
      console.log(fullUser);
      
      
      setUser(fullUser);

      return { ok: true, user: fullUser };
   };

   return (
      <AuthContext.Provider value={{ user, setUser, loading, authError, login }}>
         {children}
      </AuthContext.Provider>
   );
}

export const useAuth = () => useContext(AuthContext);